import { render, staticRenderFns } from "./KedvezmenyekB16.vue?vue&type=template&id=b91d3498&"
import script from "./KedvezmenyekB16.vue?vue&type=script&lang=js&"
export * from "./KedvezmenyekB16.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports